import { createSlice } from '@reduxjs/toolkit';
import {
    thunkApiCallGenerator
} from '../APICalls/APICalls';
import {
    deepCopy
} from './quotesAndNotificationsSlice';

const initialState = {
    userTypes: [],
    permissions: [
        "View Quotes",
        "Notifications",
        "Create Quote",
        "Create Quote Revision",
        "Print Quotes",
        "Export Quote",
        "Approve Quote",
        "Approve On Behalf",
        "Suggest Modifications",
        "Create User Type",
        "Edit User Type",
        "Edit User",
        "View All Users",
        "Create Role"
    ],
    isUserTypeEdit: false,
    isCreateUserType: false,
    currentEditCopy: {},
    currentEditIndex: -1,
    doaLoadingStatus: '',
    userTypesLoadingStatus: '',
    delegationOfAuthority: [],
    usersLoadingStatus: '',
    users: [],
    userSearch: {
        name: '',
        userType: '',
        userStatus: '',
        role: ''
    }
};

function getUsersFromUserType(userTypeObj){
    let users = [];
    if( userTypeObj && userTypeObj.userRoles ){
        userTypeObj.userRoles.forEach(userRole =>{
            userRole.users[0].activeUsers.forEach(user =>{
                users.push(
                    {
                        userType: userTypeObj.userType,
                        role: userRole.role,
                        ...user
                    }
                );
            });
        });
    }
    return users;
}

export const getUserTypes = thunkApiCallGenerator('DoA/getUserTypes');
export const putUserStatus = thunkApiCallGenerator('DoA/putUserStatus');
export const editUser = thunkApiCallGenerator('DoA/editUser');
export const putUserType = thunkApiCallGenerator('DoA/putUserType');

export const delegationOfAuthoritySlice = createSlice({
    name: 'DoA',
    initialState,
    // The `reducers` field lets us define reducers and generate associated actions
    reducers: {

        setIsUserTypeEdit: (state, action) => {
            state.isUserTypeEdit = action.payload;
        },

        setIsCreateUserType: (state, action) => {
            state.isCreateUserType = action.payload;
        },

        saveEdit: (state) => {
            state.currentEditCopy = {};
            state.isUserTypeEdit = false;
            state.currentEditIndex = -1;
        },

        cancelEdit: (state) => {
            state.userTypes[ state.currentEditIndex ] = { ...state.currentEditCopy };
            state.isUserTypeEdit = false;
            state.currentEditIndex = -1;
            state.currentEditCopy = {};
        },

        setCurrentEditCopy: (state, action) => {
            state.currentUserTypeEdit = action.payload.userType;
            state.currentEditIndex = action.payload.index;
        },

        setCurrentEditName: (state, action) => {
            state.userTypes[ state.currentEditIndex ].userType = action.payload;
        },

        setCurrentEditPermissions: (state, action) => {
            state.userTypes[ state.currentEditIndex ].permissions = action.payload;
        },

        setCurrentEditIndex: (state, action) => {
            state.currentEditIndex = action.payload;
            if ( action.payload !== -1 ){
                state.currentEditCopy = { ...state.userTypes[ action.payload ] };
            }
        },

        setUserType: (state, action) => {
            state.users[action.index].userType = action.payload;
        },

        setUserStatus: (state, action) => {
            state.users[action.index].userStatus = action.payload;
        },

        setUserSearch: (state, action) => {
            state.userSearch[ action.payload.field ] = action.payload.value;
        },

        setUserTypeLoadingStatus: (state, action) => {
            state.userTypesLoadingStatus = action.payload;
        },

        setUserTypesArray: (state, action) =>{ //temporarily store updated info until we can solve data latency issue
            state.userTypes = deepCopy(action.payload);
            let usersArray = [];
            action.payload.forEach(userType=>{
                let users = getUsersFromUserType(userType);
                usersArray.push(...users);
            });
            state.users = usersArray;
        }

    },

    extraReducers: (builder) => {
        builder.addCase(getUserTypes.pending, (state) => {

            state.userTypesLoadingStatus = 'loading';

        }).addCase(getUserTypes.fulfilled, (state, action) => {
            console.log(action.payload);
            state.userTypes = action.payload.filter(userType => userType !== null ) || [];
            let usersArray = [];
            if( action.payload ){
                action.payload.forEach(userType=>{
                    let users = getUsersFromUserType(userType);
                    usersArray.push(...users);
                });
            }
            state.users = usersArray;
            state.userTypesLoadingStatus = 'complete';

        }).addCase(getUserTypes.rejected, (state) => {

            state.userTypesLoadingStatus = 'rejected';

        }).addCase(putUserType.pending, (state) => {

            state.userTypesLoadingStatus = 'loading';

        }).addCase(putUserType.fulfilled, (state, action) => {

            state.userTypesLoadingStatus = 'complete';

        }).addCase(putUserType.rejected, (state) => {

            state.userTypesLoadingStatus = 'rejected';

        }).addCase(putUserStatus.pending, (state) => {

            state.usersLoadingStatus = 'loading';

        }).addCase(putUserStatus.fulfilled, (state, action) => {

            state.usersLoadingStatus = 'complete';

        }).addCase(putUserStatus.rejected, (state) => {

            state.usersLoadingStatus = 'rejected';

        });
        //.addCase(editUser.pending, (state) => {

        //     state.userTypesLoadingStatus = 'loading';

        // }).addCase(editUser.fulfilled, (state, action) => {

        //     state.userTypesLoadingStatus = 'complete';

        // }).addCase(editUser.rejected, (state) => {

        //     state.userTypesLoadingStatus = 'rejected';

        // });
    },

});

export const {
    // saveEdit,
    // setCurrentEditCopy,
    // setCurrentEditName,
    // setCurrentEditPermissions,
    // setCurrentEditIndex,
    setIsUserTypeEdit,
    cancelEdit,
    setUserType,
    setUserStatus,
    createUser,
    updateUser,
    setIsCreateUserType,
    setUserSearch,
    setUserTypeLoadingStatus,
    setUserTypesArray
} = delegationOfAuthoritySlice.actions;

export const selectUserTypes = state => state.DoA.userTypes;
export const selectPermissions = state => state.DoA.permissions;
export const selectCurrentEditIndex = state => state.DoA.currentEditIndex;
export const selectIsUserTypeEdit = state => state.DoA.isUserTypeEdit;
export const selectIsCreateUserType = state => state.DoA.isCreateUserType;
export const selectAllUsers = state => state.DoA.users;
export const selectUserSearch = state => state.DoA.userSearch;
export const selectUserTypesLoadingStatus = state => ({doaLoadingStatus: state.DoA.doaLoadingStatus, userTypesLoadingStatus: state.DoA.userTypesLoadingStatus, usersLoadingStatus: state.DoA.usersLoadingStatus});
export const selectUserTypeTemplate = state => {
    return {
        app: "hdmi",
        userType: "",
        permissions: [],
        roles: [],
        userRoles: []
    };
};

export default delegationOfAuthoritySlice.reducer;